import React, { FunctionComponent } from 'react';
import { SelectOption } from '../../../types/companyRegisterForm';

type Props = {
  section: 'company' | 'userAuth' | 'planPurchase';
  name: string;
  divClassName: string;
  labelName: string;
  labelHtmlFor: string;
  required: boolean;
  selectId: string;
  selectClassName: string;
  value: string;
  onChange: (section: 'company' | 'userAuth' | 'planPurchase', field: string, value: string | boolean | number) => void;
  options: SelectOption[];
};

export const Presentation: FunctionComponent<Props> = ({
  section,
  name,
  divClassName,
  labelName,
  labelHtmlFor,
  required,
  selectId,
  selectClassName,
  value,
  onChange,
  options
}) => {
  return (
    <div className={divClassName}>
      <div className="form-group__title">
        <label htmlFor={labelHtmlFor} className="col-xs-3 col-form-label">{labelName}</label>
        {required &&
          <span className="col-xs-2 high">&nbsp;必須</span>
        }
      </div>
      <div className="col-xs-7 input hidden-xs">
        <select
          id={selectId}
          className={selectClassName}
          value={value}
          onChange={(e) => onChange(section, name, e.target.value)}
        >
          <option value=""></option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
    </div>
  );
};
